import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { Floater } from 'components'

// 설정 메인
import Setting from './Setting'

// 설정 내 정보
import MyInfoModify from './MyInfoModify'
import MyInfoNumber from './MyInfoNumber'
import MyInfoEmail from './MyInfoEmail'
import MyInfoResign from './MyInfoResign'
import MyInfoOut from '../member/MyInfoOut'
import ResignSuccess from './ResignSuccess'

import MyInfoNumberCert from './MyInfoNumberCert'

// 설정 인증 및 보안
import CertiMenu from './CertiMenu'
import CertiManage from './CertiManage'
import CertiBring from './CertiBring'

// 설정 알림설정
import AlarmSetting from './AlarmSetting'
import AgreeLayer from './AgreeLayer'

// 설정 공지사항
import Notice from './Notice'
import NoticeDetail from './NoticeDetail'

// 설정 FAQ
import Faq from './Faq'
import FaqSearch from './FaqSearch'
import FaqSearchNone from './FaqSearchNone'

// 설정 문의하기
import Question from './Question'
import QuestionDetail from './QuestionDetail'

// 설정 이벤트
import EventLayer from './EventLayer'
import EventDetail from './EventDetail'

// 설정 약관/동의
import TermsAgree from './TermsAgree'
import TermsAgreeDetail from './TermsAgreeDetail'

// 설정 앱버전
import AppVer from './AppVer'

import NotFound from 'views/NotFound'

// setting
const Index = () => {

	return (
		<>
			<Floater>
				<li><Link to="">설정 메인</Link></li>
				<li><Link to="myInfoModify">내 정보 변경</Link></li>
				<li><Link to="myInfoNumber">휴대폰번호 수정</Link></li>
				<li><Link to="myInfoEmail">이메일주소 수정</Link></li>
				<li><Link to="myInfoResign">탈퇴</Link></li>
				<li><Link to="myInfoOut">탈퇴 확인</Link></li>
				<li><Link to="resignSuccess">탈퇴 완료</Link></li>
				<li><Link to="certiMenu">인증/보안</Link></li>
				<li><Link to="certiManage">인증서관리</Link></li>
				<li><Link to="certiBring">인증서 가져오기</Link></li>
				<li><Link to="alarmSetting">알림 설정</Link></li>
				<li><Link to="agreeLayer">마케팅 정보 수신동의 레이어</Link></li>
				<li><Link to="notice">공지사항</Link></li>
				<li><Link to="noticeDetail">공지사항 상세보기</Link></li>
				<li><Link to="faq">faq</Link></li>
				<li><Link to="faqSearch">faq 검색</Link></li>
				<li><Link to="faqSearchNone">faq 검색결과 없음</Link></li>
				<li><Link to="question">문의하기</Link></li>
				<li><Link to="questionDetail">문의하기 상세</Link></li>
				<li><Link to="event">이벤트</Link></li>
				<li><Link to="eventDetail">이벤트 상세</Link></li>
				<li><Link to="termsAgree">약관/동의</Link></li>
				<li><Link to="termsAgreeDetail">약관/동의 상세</Link></li>
				<li><Link to="appVer">앱버전</Link></li>
			</Floater>
			<Routes>
				<Route path="/myInfoModify" element={<MyInfoModify />} /> { /* 내 정보 변경 */}
				<Route path="/myInfoNumber" element={<MyInfoNumber />} /> { /* 휴대폰번호 수정 */}
				<Route path="/MyInfoNumberCert" element={<MyInfoNumberCert />} /> { /* 휴대폰번호 수정 인증 */}
				<Route path="/myInfoEmail" element={<MyInfoEmail />} /> { /* 이메일주소 수정 */}
				<Route path="/myInfoResign" element={<MyInfoResign />} /> { /* 탈퇴 */}
				<Route path="/myInfoOut" element={<MyInfoOut />} /> { /* 탈퇴 확인 */}
				<Route path="/resignSuccess" element={<ResignSuccess />} /> { /* 탈퇴 완료 */}

				<Route path="/certiMenu" element={<CertiMenu />} /> { /* 인증/보안 */}
				<Route path="/certiManage" element={<CertiManage />} /> { /* 인증서관리 */}
				<Route path="/certiBring" element={<CertiBring />} /> { /* 인증서 가져오기 */}

				<Route path="/alarmSetting" element={<AlarmSetting />} /> { /* 알림 설정 */}
				<Route path="/agreeLayer" element={<AgreeLayer />} /> { /* 마케팅 정보 수신동의 레이어 */}

				<Route path="/notice" element={<Notice />} /> { /* 공지사항 */}
				<Route path="/noticeDetail" element={<NoticeDetail />} /> { /* 공지사항 상세보기 */}

				<Route path="/faq" element={<Faq />} /> { /* faq */}
				<Route path="/faqSearch" element={<FaqSearch />} /> { /* faq 검색 */}
				<Route path="/faqSearchNone" element={<FaqSearchNone />} /> { /* faq 검색결과 없음 */}

				<Route path="/question" element={<Question />} /> { /* 문의하기 */}
				<Route path="/questionDetail" element={<QuestionDetail />} /> { /* 문의하기 상세 */}

				<Route path="/event" element={<EventLayer />} /> { /* 이벤트 */}
				<Route path="/eventDetail" element={<EventDetail />} /> { /* 이벤트 상세 */}

				<Route path="/termsAgree" element={<TermsAgree />} /> { /* 약관/동의 */}
				<Route path="/termsAgreeDetail" element={<TermsAgreeDetail />} /> { /* 약관/동의 상세 */}

				<Route path="/appVer" element={<AppVer />} /> { /* 앱버전 */}

				<Route path="/" element={<Setting />} /> { /* 설정 메인 */}
				<Route path="*" element={<NotFound />} />
			</Routes>
		</>
	)
}

export default Index